module.exports = __webpack_public_path__ + "static/img/Uber Eats.b706ed6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Uber Eats.png
// module id = jl1D
// module chunks = 4